import React from 'react'
import { observer } from 'mobx-react'
import { i18nTranslate } from 'src/utils'
import { Row, Container } from 'react-bootstrap'
import TagManager from 'react-gtm-module'
import { tryJSONParse } from 'src/utils'
import { AccordionBlockPDP } from 'src/views/components/AccordionBlockPDP'
import {
  getProductPDPTitle,
  enablePdpRedesign,
  getMedia,
  isYouTubeVideo,
} from 'src/utils/commonUtils'
import { APPConfig } from 'config/appConfig'
import './styles.scss'

@observer
class ProductHowtoUseit extends React.Component {
  nameSpace = 'ssr-resource'
  handleHowToUseVideoPlay = () => {
    const product = this.props?.product || {}
    const { name, productId, skuId } = product

    /**
     * @info
     * GTM Datalayer - Send event when vide play button is clicked on PDP - How To Use It Section.
     */
    TagManager.dataLayer({
      dataLayer: {
        event: 'videoPlayed',
        name: name || '',
        productId: productId || '',
        skuId: skuId || '',
        section: 'PDP How To Use It',
        pagePath: `/product/:id`,
        pageTitle: 'Product Details Page',
        platform: 'equinox',
      },
    })
  }
  renderTitle = () => {
    const { isAccordionType = false } = this.props
    const howToUseItLabel = getProductPDPTitle(
      this.props.product?.tempProperties,
      'usage'
    )
    return (
      <Row
        as="h3"
        className={`about-title ${
          isAccordionType ? 'text-uppercase' : 'border-light-grey'
        }  ${enablePdpRedesign() ? 'pdp-redesign-title' : ''}`}
        noGutters>
        {howToUseItLabel ||
          i18nTranslate('pdp.howToUseIt', 'How to Use It', {
            nameSpace: this.nameSpace,
          })}
      </Row>
    )
  }

  renderDescription = (Data = '[]') => {
    const parsedDescription = tryJSONParse(Data)
    const isArray = Array.isArray(parsedDescription)
    if (isArray) {
      return (
        <ul>
          {parsedDescription.map((desc, index) => {
            if (typeof desc === 'object') {
              return <li key={`desc-${index}`}>{desc?.description}</li>
            } else if (desc) {
              return <li key={`desc-${index}`}>{desc}</li>
            }
            return ''
          })}
        </ul>
      )
    }
    return (
      <Container>
        <Row
          className="about-product pb-3 text-dark"
          noGutters
          dangerouslySetInnerHTML={{
            __html: Data,
          }}
        />
      </Container>
    )
  }
  renderProductWarnings = warnings => {
    return (
      <>
        {warnings && (
          // <div>
          //   <div className="d-flex items-center">
          //      <div>
          //       {<Icons
          //         name="product-icon"
          //         icontype="danger-warning"
          //         width="20px"
          //         color="#fd983b"
          //       /> }
          //       {warnings && warnings?.length > 0 && (
          //         <h5 className="subhead-m">
          //           Warnings<span className="mr-1">: </span>
          //         </h5>
          //       )}
          //     </div> }
          <div className="font-italic">{warnings}</div>
          //   </div>
          // </div>
        )}
      </>
    )
  }
  render() {
    const product = this.props?.product || {}
    const usage = product.usage || '{}'
    let steps = []
    let video = {}
    let additionalText = []
    let recommendations = []
    let warnings = ''
    let usageObj = {}
    try {
      usageObj = JSON.parse(usage)
      additionalText = usageObj.additionalText || []
      recommendations = usageObj.recommendations || []
      steps = usageObj.steps || []
      warnings = usageObj.warnings || ''
      if (usageObj.video?.url) {
        video = usageObj.video
      } else if (
        usageObj.youTubeVideoId ||
        usageObj.url ||
        usageObj?.image?.url
      ) {
        video = {
          youTubeVideoId: usageObj.youTubeVideoId,
          url: usageObj?.image?.url || usageObj.url,
          alt: usageObj.alt,
          thumbnail: usageObj.thumbnail,
        }
      } else {
        video = {}
      }
    } catch (e) {
      console.log('Data parse error::: ProductHowtoUseit' + e)
    }
    const enableNewPDPStyle =
      APPConfig?.getAppConfig()?.enableNewPDPStyle === 'true'
    return (
      <>
        {(steps?.length > 0 ||
          video?.url?.length > 0 ||
          additionalText?.length > 0 ||
          recommendations?.length > 0) && (
          <div
            className={`${enablePdpRedesign() ? 'product-accordion-wrapper-pdp' : ''} product-accordion-wrapper`}
            id="usage">
            <AccordionBlockPDP
              title={this.renderTitle()}
              isDefaultOpen={false}
              className="accordion-description"
              dataTestId="qa-pdp-how-to-use">
              {(video?.youTubeVideoId || video?.url) && (
                <div className="pdp-videos-howtouse ">
                  {getMedia({
                    url: video?.url,
                    youTubeVideoId: video?.youTubeVideoId,
                    alt: video?.alt,
                    index: 0,
                    isToShowControls: true,
                    thumbnail: video?.thumbnail,
                  })}
                </div>
              )}
              <Container className="pdp-accordion-content-container">
                <div className="how-to-use-accordion align-items-start justify-content-start flex-wrap">
                  {steps?.length > 0 && (
                    <div
                      className="use-steps p-0"
                      data-testid="qa-pdp-how-to-use-description">
                      {!enableNewPDPStyle && (
                        <h4 className="subhead-m">STEPS</h4>
                      )}
                      <ul className="paragraph-l">
                        {steps.map((step, index) => (
                          <div
                            key={index}
                            className="how-to-use"
                            data-testid={`qa-pdp-how-to-use-info-${index + 1}`}>
                            <div className="how-to-use-steps-index">
                              {index + 1}
                            </div>
                            <div className="how-to-use-steps">{step}</div>
                          </div>
                        ))}
                      </ul>
                    </div>
                  )}
                  {recommendations?.length > 0 && (
                    <div className="recommendations">
                      <h4
                        className="subhead-m"
                        data-testid="qa-pdp-how-to-use-recommendations">
                        {i18nTranslate('recommendations', 'Recommendations', {
                          nameSpace: 'ssr-resource',
                        })}
                      </h4>
                      <ul className="p-0 paragraph-m">
                        {recommendations.map((recom, index) => (
                          <li key={index}>{recom}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {additionalText?.length > 0 && (
                    <div
                      className="additional-text"
                      data-testid="qa-pdp-how-to-use-additional-text">
                      <ul
                        className={`p-0 paragraph-m ${enablePdpRedesign() ? 'pdp-redesign-desc-text' : ''}`}>
                        {additionalText.map((additional, index) => (
                          <li key={index}>{additional}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {warnings?.length > 0 && this.renderProductWarnings(warnings)}
                  {/* CX121-3606 ^ warning support added */}
                </div>
              </Container>
            </AccordionBlockPDP>
          </div>
        )}
      </>
    )
  }
}

export { ProductHowtoUseit }
